import { BuiltCampaignControllerTrigger } from "src/shared/store/campaign-built/model/BuiltCampaignControllerTrigger";
import Strings from "src/shared/Strings";
export class BuiltCampaignControllerTriggerReferredByEvent extends BuiltCampaignControllerTrigger {
    constructor(response, context) {
        super(response, context);
        this.referralOriginator = response.referral_originator;
    }
    getDisplayName() {
        // Handle evaluatable trigger_name
        const name = typeof this.trigger_name === "string"
            ? this.trigger_name
            : String(this.trigger_name);
        return Strings.capitalize(name);
    }
}
export const isBuiltCampaignControllerTriggerReferredByEvent = (trigger) => {
    return trigger instanceof BuiltCampaignControllerTriggerReferredByEvent;
};
